import React, {
  Component,
} from "react"; 
{/*import Particles from "react-particles-js"; */}
import "./App.css";
import logo from "./images/hamburger.svg";
import menu from "./images/hamburger.svg";
import img01 from "./images/dm.svg";
import img02 from "./images/v261-minty-financedoodle-35.png";
import img03 from "./images/drawing.svg";
import img04 from "./images/tradehero.png";
import img05 from "./images/lock.svg";
import img06 from "./images/stock.svg";
import imgsoc1 from "./images/facebook.svg";
import imgsoc2 from "./images/instagram.svg";
import imgsoc3 from "./images/twitter.svg";
import imgsoc4 from "./images/gmail.svg";

import Calculator from "./calculator";
import Table from "./table";
{
  /*import Apichart from './apichart';*/
}
let Width=function(){ return(window.screen.width)/15}
 
class App extends Component {
  render() {
    return (
      <div>
        <div className="app">
          <header>
            <nav>
              <h1>Logo</h1>
              <img className="menu" src={menu} alt=""></img>
              <div className="nav-open">
                <div className="contact">
                  <h3>Contact</h3>
                  <h3>About Us</h3>
                  <h3>Policy</h3>
                  <h3>Exchange</h3>
                  <h3>Lending</h3>
                </div>
              </div>
            </nav>
          </header>
          <div className="box">
            <div id="particles-js"></div>
            <div className="btext">
              <h1>Trade in 16+ Coins with the Highest Liquidity.</h1>
              <br></br>
              <p>
                Trade with leverage on a single account, across liquidity of
                Binance, Huobi and HitBTC.
              </p>
              <br></br>
              <input type="email" placeholder="Enter your email"></input>
              <button>GET STARTED</button>
            </div>
            <div className="btext img">
              <img src={img04} alt=""></img>
            </div>
          </div>

      {/*<Particles
            params={{
              "particles": {
                "number": {
                  "value": Width(),
                },
                "color": {
                  "value": "f9f3f4a0",
                },
                "shape": {
                  "type": "circle",
                  "stroke": {
                    "width": 1,
                    "color": "#ccc",
                  },
                },
                "opacity": {
                  "value": 0.5,
                  "random": true,
                },
                "size": {
                  "value": 2,
                },
                "line_linked": {
                  "enable": true,
                  "distance": 130,
                },
                "move": {
                  "enable": true,
                  "speed": 2.0,
                  "bounce": false,
                  "out_mode": "out", // What it'll do when it reaches the end of the canvas, either "out" or "bounce".
                  "attract": {
                    // Make them start to clump together while moving.
                    "enable": true,
                    "rotateX": 1200,
                    "rotateY": 1200,
                  },
                },
              },
              "interactivity": {
                "events": {
                  "onhover": {
                    "enable": true,
                    "mode": "grab",
                  },
                  "onclick": {
                    "enable": true,
                    "mode": "push",
                  },
                  "resize": true,
                },
              },
            }}
            Style={{
              width: "100%",
              height: "100%",
            }}
          ></Particles> */}
        </div>
        <div className="buttonholder">
          <button>Sign In</button>
          <button>Sign Up</button>
        </div>
        <hr />
        <div className="description">
          <img className="back" src={img03} alt=""></img>
          <div className="first des">
            <div className="imgd">
              <img src={img01} alt=""></img>
            </div>
            <div className="first words">
              <h1>Simple to Use</h1>
              <p>
                Experience the power of a fast, safe and secure platform that
                makes trading effortless
              </p>
            </div>
          </div>
          <hr />
          <div className="second des">
            <div className="first head words">
              <h1>Margin Centre</h1>
              <p>
                Trade in 250+ Altcoins with upto 6x leverage with massive
                liquidity from world’s leading exchanges
              </p>
            </div>
            <div className="imgd">
              <img src={img02} alt=""></img>
            </div>
          </div>
          <hr />
          <div className="third des">
            <div className="imgd imgd1">
              <img src={img05} alt=""></img>
            </div>
            <div className="words">
              <h1>Security First</h1>
              <p>
                With multi-signature authentication, cold wallet storage and
                DDos Protection enjoy highest security
              </p>
            </div>
          </div>
          <hr />
          <div className="fourth des">
            <div className="words">
              <h1>Limitless Trading</h1>
              <p>
                With a near limitless order book, never worry about any
                limitations when you trade with CoinDCX
              </p>
            </div>
            <div className="imgd imgd1">
              <img src={img06} alt=""></img>
            </div>
          </div>
        </div>
        <hr></hr>
        <Table></Table>
        <div className="productbox">
          <h2>Our Product</h2>
          <hr></hr>
          <div className="productcard">
            <h3>TRUmargin</h3>
            <p>Coming soon...</p>
          </div>
          <div className="productcard">
            <h3>TRUinsta</h3>
            <p>Coming soon...</p>
          </div>
          <div className="productcard">
            <h3>TRUtrade</h3>
            <p>Coming soon...</p>
          </div>
          <div className="productcard">
            <h3>TRUlend</h3>
            <p>Coming soon...</p>
          </div>
          <div className="productcard">
            <h3>TRUfutures</h3>
            <p>Coming soon...</p>
          </div>
          <div className="productcard">
            <h3>TRUconvert</h3>
            <p>Coming soon...</p>
          </div>
        </div>

        <Calculator></Calculator>

        <footer>
          <div className="footerbox">
            <div className="f1 footersection">
              <h3 className="a">Company</h3>
              <h3 className="b">Products</h3>
              <h3 className="c">Support</h3>
              <h3 className="d">Social Links</h3>
            </div>
            <div className="f2 footersection">
              <div className="a">
                <p>Security</p>
                <p>Blog</p>
                <p>About Us</p>
                <p>Intro to Margins Trading</p>
                <p>Intro to Futures Trading</p>
                <p>Year in Review</p>
                <p>Fee Structure</p>
                <p>Privacy Policy</p>
                <p>Terms and Condition</p>
                <p>AML Policy</p>
                <p>Refund/Cancellation Policy</p>
                <p>Refferal Program</p>
              </div>
              <div className="b">
                <p>TRUmargin</p>
                <p>TRUtrade</p>
                <p>TRUfutures</p>
                <p>TRUinsta</p>
                <p>TRUconvert</p>
                <p>TRUlend</p>
                <p>TRUmarkets</p>
              </div>
              <div className="c">
                <p>Contact Support</p>
                <p>Request for Coin Listing</p>
                <p>Frequently Asked Question(FAQ)</p>

                <ul>
                  <h3>Contact Us</h3>
                  <li>
                    <h4>Customer Support</h4>: support@TetraUnits.com
                  </li>
                  <li>
                    <h4>Team</h4>: team@TetraUnits.com
                  </li>
                  <li>
                    <h4>Press</h4>: pr@TetraUnits.com
                  </li>
                </ul>
              </div>
              <div className=" social d">
                <img src={imgsoc1} alt=""></img>Facebook<br></br>
                <img src={imgsoc2} alt=""></img>Instagram<br></br>
                <img src={imgsoc3} alt=""></img>Twitter<br></br>
                <img src={imgsoc4} alt=""></img>Gmail
              </div>
            </div>
          </div>
          <div className="f3 footersection">By Prodipta Halder ❤️.</div>
        </footer>
      </div>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js